import React from 'react';
import SEO from '../../partials/components/SEO';

// components
import SliderArea2 from './sections/SliderArea2';
import ExpertsCTO from './sections/ExpertsCTO';
import AccurateTesting from './sections/AccurateTesting';
import HowTestingWorks from './sections/HowTestingWorks';
import CallToAction from './sections/CallToAction';
import IlluminaVideos from './sections/IlluminaVideos';
import Layout from '../../partials_refactored/Layout';
import PageScrollTop from '../../utils/PageScrollTop';
import { GeneralComponentsStyle } from '../styles/GeneralComponentsStyle';

//content
import { homepage as content } from './content/homepage';

const AtlanticMain = () => {
  return (
    <Layout>
      <PageScrollTop>
        <GeneralComponentsStyle>
          <SEO title="Atlantic Labs" />
          <main className="page-wrapper">
            <SliderArea2 content={content.bannerData2} />
            <ExpertsCTO content={content.expertsCTO} bgColor="#f4f5f9" />
            <AccurateTesting content={content.accurateTesting} bgColor="#0d2f59" />
            <HowTestingWorks content={content.howTestingWorks} bgColor="#f9f9f9" />
            <CallToAction content={content.callToAction} bgColor={'#f9f9f9'} />
            <IlluminaVideos bgColor={'#f4f5f9'} content={content.illuminaVideos} />
          </main>
        </GeneralComponentsStyle>
      </PageScrollTop>
    </Layout>
  );
};
export default AtlanticMain;
